import { render, staticRenderFns } from "./RankTable.vue?vue&type=template&id=355be10a&scoped=true&"
import script from "./RankTable.vue?vue&type=script&lang=ts&"
export * from "./RankTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355be10a",
  null
  
)

export default component.exports